import script from "./CurrencyFlag.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrencyFlag.vue?vue&type=script&setup=true&lang=js"

import "./CurrencyFlag.vue?vue&type=style&index=0&id=fa800c6e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa800c6e"]])

export default __exports__